import React from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { theme } from './utils/theme';
import { useTawkTo } from './hooks/useTawkTo';
import { usePageMeta } from './hooks/usePageMeta';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { Experts } from './components/Experts';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
export function App() {
  usePageMeta();
  useTawkTo();
  return <ChakraProvider theme={theme} data-id="element-0" data-mp="28t4j27cxrypu">
      <Box w="100%" minH="100vh" bg="cream.50" data-id="element-1" data-mp="28s2ztflro5x1">
        <Header data-id="element-2" data-mp="23u9v6r043jyv" />
        <Box as="main" data-id="element-3" data-mp="23utas12ahw9q">
          <Hero data-id="element-4" data-mp="23ti8y6semyl9" />
          <Services data-id="element-5" data-mp="3ijxsv0nzqion" />
          <WhyUs data-id="element-6" data-mp="3ikr0s4yore8d" />
          <About data-id="element-7" data-mp="3ij64a9st9l7v" />
          <Gallery data-id="element-8" data-mp="3ijpcgysnsv8p" />
          <Experts data-id="element-9" data-mp="3ii4ro0w5cqo1" />
          <Testimonials data-id="element-10" data-mp="3mlax56bfqdtg" />
          <Contact data-id="element-11" data-mp="3mkhm3t5g125i" />
        </Box>
        <Footer data-id="element-12" data-mp="3mjpyb4i388ps" />
        <Disclaimer data-id="element-13" data-mp="3mj6jhwnqi0fz" />
        <FloatingCta data-id="element-14" data-mp="3rbr9en3irte8" />
      </Box>
    </ChakraProvider>;
}